import { MAX_NICKNAME_LENGTH } from '@/consts';
import Input from '@/components/atoms/input';
import * as ViewModel from '@/core/presenter/viewModel';
import Button from '@/components/atoms/button';

interface IProps {
    nickname: string;
    nicknameGuideMsg: string;
    onChangeNickname: (e: React.SyntheticEvent<HTMLInputElement>) => void;
    onClickNicknameCheckBtn: () => void;
    onKeyDownNickname: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const InputNickname = ({nickname, nicknameGuideMsg, onChangeNickname, onClickNicknameCheckBtn, }: IProps): JSX.Element => {
    return (
        <div className="form-group-info-join-sms-2 form-group-join-sms-2 label">
            <label htmlFor="phone" className="w body-n-n pad-b mar-b">닉네임을 입력해주세요.</label>
            <div className="input-group-join-sms-2 pad">
                <Input 
                    id="auth-code" 
                    type="text" 
                    placeholder="닉네임 입력" 
                    className="pnum-input body-n-n ml-gray" 
                    validatorType={ViewModel.InputValidatorType.NICKNAME}
                    value={nickname}
                    onChange={onChangeNickname}
                    maxLength={MAX_NICKNAME_LENGTH}
                    pattern="^[a-zA-Z0-9가-힣]+$"            
                    // onKeyDown={onKeyDownNickname}
                />
                <Button 
                    caption={"중복확인"} 
                    className="request-button body-s-n" 
                    onClick={onClickNicknameCheckBtn}
                />
            </div>         
            <div className="alert-msg-join-sms-2 body-s-n">
                <p>{nicknameGuideMsg}</p>
            </div>
        </div>
    )
}

export default InputNickname;